import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostBinding,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Renderer2,
  ContentChildren,
  QueryList,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'pg-topbar, grit-topbar',
  templateUrl: './pg-topbar.component.html',
  styleUrls: ['./pg-topbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'PgTopbar, pgTopbar, gritTopbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PgTopbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.grit-topbar')
  @HostBinding('class.pg-topbar')
  readonly classPgTopbar = true;

  @Input('fixed')
  fixed = false;

  @ViewChild('topbarSpacer', { static: true })
  _topbarSpacerChild: ElementRef;
  @ViewChild('topbarWrapper', { static: true })
  _topbarWrapperChild: ElementRef;

  observer: MutationObserver;

  get _headerWrapperEl(): HTMLElement {
    return this._topbarWrapperChild.nativeElement;
  }

  get _headerSpacerEl(): HTMLElement {
    return this._topbarSpacerChild.nativeElement;
  }

  constructor(public elementRef: ElementRef, private _renderer: Renderer2) {}

  ngOnInit() {}

  ngOnDestroy() {}

  ngAfterViewInit() {
    this.recalculateSpacerHeight();

    // UI hack
    setTimeout(() => {
      this.recalculateSpacerHeight();
    }, 150);
    setTimeout(() => {
      this.recalculateSpacerHeight();
    }, 1000);
  }

  recalculateSpacerHeight() {
    if (this.fixed) {
      this._headerSpacerEl.style.display = 'block';
      this._headerSpacerEl.style.height = `${this._headerWrapperEl.offsetHeight}px`;
      this._renderer.addClass(this._headerWrapperEl, 'fixed-topbar');
    } else {
      this._headerSpacerEl.style.display = 'none';
    }
  }
}
